import React from 'react';
import { FormGroup } from '../../../common/formInputs/styles/common';

function TextInputAi({
  placeholder, rows, onChange, error, valid, max, value,
}) {
  return (
    <FormGroup className=" w-100 h-100 my-0">
      <textarea
        placeholder={placeholder}
        rows={rows}
        maxLength={max}
        value={value}
        className={`form-control text-center ${valid ? 'is-valid' : ''} ${error ? 'is-invalid' : ''} w-100 h-100`}
        onChange={(e) => onChange(e)}
      />
      <div className="invalid-feedback">
        {error}
      </div>
    </FormGroup>
  );
}

export default TextInputAi;
